// 定义所需的 mutations
const mutations = {
    putShowList(state,data){
        state.showList=data;
    }

}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/home/mutations.js